import Vue from 'vue'
import App from './App.vue'
import store from './store'
import toRem from './utils/toRem'
toRem()
window.addEventListener('resize', toRem)

// var VConsole = require('vconsole');
// 初始化 vConsole
// var vConsole = new VConsole();


import axios from 'axios';
var jsonpAdapter = require('axios-jsonp');
// 设置axios的JSONP适配器
axios.defaults.adapter = jsonpAdapter;

// 将axios添加到Vue的原型上，这样在所有组件中都可以使用this.axios来进行请求
Vue.prototype.$axios = axios;

//全局封装接口请求调用类
// 在任何组件中，你可以通过 this.$api 来访问 ApiService 的方法。
// import ApiService from './utils/ApiService';
// Vue.prototype.$api = ApiService;

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
